/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelChargeCode.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/charge-code";

export class AutogenModelChargeCode<RowType extends ModelRow> extends Endpoint<RowType, RowChargeCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowChargeCode extends ModelRow<RowChargeCodeFields> {
	constructor(values?: Partial<RowChargeCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowChargeCodeFields {
	acct_int_id: string;
	acct_int_name: string;
	amount: number;
	charge_rate_method: string;
	co_amount: number;
	"co_deduct_code.advance_limit": number;
	"co_deduct_code.advance_limit_c": string;
	"co_deduct_code.advance_limit_d": Date;
	"co_deduct_code.advance_limit_n": number;
	"co_deduct_code.advance_limit_r": number;
	"co_deduct_code.amount": number;
	"co_deduct_code.amount_c": string;
	"co_deduct_code.amount_d": Date;
	"co_deduct_code.amount_n": number;
	"co_deduct_code.amount_r": number;
	"co_deduct_code.city_tax_flag": string;
	"co_deduct_code.code_type": string;
	"co_deduct_code.company_id": string;
	"co_deduct_code.county_tax_flag": string;
	"co_deduct_code.create_other_pay": string;
	"co_deduct_code.dispatcher_flag": string;
	"co_deduct_code.emp_fica_hi_flag": string;
	"co_deduct_code.emp_fica_oadi_flag": string;
	"co_deduct_code.empr_fica_hi_flag": string;
	"co_deduct_code.empr_fica_oadi_flg": string;
	"co_deduct_code.empr_train_flag": string;
	"co_deduct_code.exclude_commissions": string;
	"co_deduct_code.federal_tax_flag": string;
	"co_deduct_code.fui_flag": string;
	"co_deduct_code.glid": string;
	"co_deduct_code.id": string;
	"co_deduct_code.is_active": string;
	"co_deduct_code.is_cost_business": string;
	"co_deduct_code.overweight_pay": string;
	"co_deduct_code.pfml_flag": string;
	"co_deduct_code.sdi_flag": string;
	"co_deduct_code.short_desc": string;
	"co_deduct_code.state_tax_flag": string;
	"co_deduct_code.sui_flag": string;
	"co_deduct_code.weight_cutoff": number;
	"co_deduct_code.weight_cutoff_um": string;
	co_deduct_code_id: string;
	"co_gl_account.ap_xfer_method": string;
	"co_gl_account.bill_xfer_method": string;
	"co_gl_account.cash_flow_type": string;
	"co_gl_account.cash_xfer_method": string;
	"co_gl_account.company_id": string;
	"co_gl_account.descr": string;
	"co_gl_account.drs_xfer_method": string;
	"co_gl_account.enclose_paren": string;
	"co_gl_account.enforce_currency_segment": string;
	"co_gl_account.esc_credit_percent": number;
	"co_gl_account.esc_debit_percent": number;
	"co_gl_account.esc_driver_int_pct": number;
	"co_gl_account.esc_interest_glid": string;
	"co_gl_account.esc_is_interest": string;
	"co_gl_account.esc_last_post_date": Date;
	"co_gl_account.esc_payee_int_ded": string;
	"co_gl_account.fl_xfer_method": string;
	"co_gl_account.ic_type": string;
	"co_gl_account.id": string;
	"co_gl_account.is_advertising": string;
	"co_gl_account.is_driver_debt": string;
	"co_gl_account.is_escrow": string;
	"co_gl_account.is_leased_purchase": string;
	"co_gl_account.is_roi": string;
	"co_gl_account.is_safety": string;
	"co_gl_account.is_tire_cost": string;
	"co_gl_account.is_write_off": string;
	"co_gl_account.isactive": string;
	"co_gl_account.off_xfer_method": string;
	"co_gl_account.posting_type": string;
	"co_gl_account.rev_sign": string;
	"co_gl_account.seg_alloc": string;
	"co_gl_account.type_id": string;
	"co_gl_account.vm_xfer_method": string;
	co_pay_method: string;
	co_payee_acct: string;
	co_percent: number;
	company_id: string;
	descr: string;
	edi_code: string;
	exclude_commissions: string;
	glid: string;
	id: string;
	incl_in_freight: string;
	is_fuel_surcharge: string;
	is_intermodal: string;
	is_logix_licensed: boolean;
	is_taxable: string;
	is_tonu: string;
	ltl_allocation_method: string;
	oo_amount: number;
	"oo_deduct_code.advance_limit": number;
	"oo_deduct_code.advance_limit_c": string;
	"oo_deduct_code.advance_limit_d": Date;
	"oo_deduct_code.advance_limit_n": number;
	"oo_deduct_code.advance_limit_r": number;
	"oo_deduct_code.amount": number;
	"oo_deduct_code.amount_c": string;
	"oo_deduct_code.amount_d": Date;
	"oo_deduct_code.amount_n": number;
	"oo_deduct_code.amount_r": number;
	"oo_deduct_code.city_tax_flag": string;
	"oo_deduct_code.code_type": string;
	"oo_deduct_code.company_id": string;
	"oo_deduct_code.county_tax_flag": string;
	"oo_deduct_code.create_other_pay": string;
	"oo_deduct_code.dispatcher_flag": string;
	"oo_deduct_code.emp_fica_hi_flag": string;
	"oo_deduct_code.emp_fica_oadi_flag": string;
	"oo_deduct_code.empr_fica_hi_flag": string;
	"oo_deduct_code.empr_fica_oadi_flg": string;
	"oo_deduct_code.empr_train_flag": string;
	"oo_deduct_code.exclude_commissions": string;
	"oo_deduct_code.federal_tax_flag": string;
	"oo_deduct_code.fui_flag": string;
	"oo_deduct_code.glid": string;
	"oo_deduct_code.id": string;
	"oo_deduct_code.is_active": string;
	"oo_deduct_code.is_cost_business": string;
	"oo_deduct_code.overweight_pay": string;
	"oo_deduct_code.pfml_flag": string;
	"oo_deduct_code.sdi_flag": string;
	"oo_deduct_code.short_desc": string;
	"oo_deduct_code.state_tax_flag": string;
	"oo_deduct_code.sui_flag": string;
	"oo_deduct_code.weight_cutoff": number;
	"oo_deduct_code.weight_cutoff_um": string;
	oo_deduct_code_id: string;
	"oo_gl_account.ap_xfer_method": string;
	"oo_gl_account.bill_xfer_method": string;
	"oo_gl_account.cash_flow_type": string;
	"oo_gl_account.cash_xfer_method": string;
	"oo_gl_account.company_id": string;
	"oo_gl_account.descr": string;
	"oo_gl_account.drs_xfer_method": string;
	"oo_gl_account.enclose_paren": string;
	"oo_gl_account.enforce_currency_segment": string;
	"oo_gl_account.esc_credit_percent": number;
	"oo_gl_account.esc_debit_percent": number;
	"oo_gl_account.esc_driver_int_pct": number;
	"oo_gl_account.esc_interest_glid": string;
	"oo_gl_account.esc_is_interest": string;
	"oo_gl_account.esc_last_post_date": Date;
	"oo_gl_account.esc_payee_int_ded": string;
	"oo_gl_account.fl_xfer_method": string;
	"oo_gl_account.ic_type": string;
	"oo_gl_account.id": string;
	"oo_gl_account.is_advertising": string;
	"oo_gl_account.is_driver_debt": string;
	"oo_gl_account.is_escrow": string;
	"oo_gl_account.is_leased_purchase": string;
	"oo_gl_account.is_roi": string;
	"oo_gl_account.is_safety": string;
	"oo_gl_account.is_tire_cost": string;
	"oo_gl_account.is_write_off": string;
	"oo_gl_account.isactive": string;
	"oo_gl_account.off_xfer_method": string;
	"oo_gl_account.posting_type": string;
	"oo_gl_account.rev_sign": string;
	"oo_gl_account.seg_alloc": string;
	"oo_gl_account.type_id": string;
	"oo_gl_account.vm_xfer_method": string;
	oo_pay_method: string;
	oo_payee_acct: string;
	oo_percent: number;
	pay_company_hourly_driver: string;
	prev_flag: string;
	rate: number;
	wf_min_charge: number;
	wf_occ_doctype: string;
	wf_occ_queue: string;
	who_to_pay: string;
}

